import {createFileRoute, redirect} from "@tanstack/react-router";
import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {findConfigPageIdByType} from "~/workspaceConfig/configPageIds";
import {hasWorkspaceUiConfig} from "~/workspaceConfig/configRuntime";
import {PageType} from "@vesta/vos-types/modules/workspaceLevel/workspaceUiConfigs/domain/WorkspaceConfig";
import {ErrorComponent} from "~/routes/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottopilot/_ottopilotScaffold/source-wise-lead-funnel/-errorComponent";
import {NotFoundComponent} from "~/routes/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottopilot/_ottopilotScaffold/source-wise-lead-funnel/-notFoundComponent";
import {PendingComponent} from "~/routes/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottopilot/_ottopilotScaffold/source-wise-lead-funnel/-pendingComponent";
import {RouteComponent} from "~/routes/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottopilot/_ottopilotScaffold/source-wise-lead-funnel/-routeComponent";

export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottopilot/_ottopilotScaffold/source-wise-lead-funnel",
)({
    beforeLoad: ({params}) => {
        if (hasWorkspaceUiConfig(params.workspaceId as Uuid)) {
            const pageKey = findConfigPageIdByType(params.workspaceId, PageType.AmaronSourceWiseLeadFunnel);
            if (pageKey !== undefined) {
                throw redirect({to: "/w/$workspaceId/$pageKey", params: {workspaceId: params.workspaceId, pageKey}, replace: true});
            }
        }
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
